import { cancelTicket } from "@services/api";
import { store } from "@store";
import { actions as snackbarActions } from "@reducers/snackbarReducer";
import analytics from "@services/analytics";
import { SUPPORT_FLOW } from "@constants/analyticsEventsCT";

const payload = (message) => ({
  shouldShow: true,
  message,
  position: "bottom",
  bottom: 0,
  autoHidingTime: 3000,
  autoHide: true,
  actionText: "Okay",
  actionHandler: (e) => {
    store.dispatch(snackbarActions.hideSnackbar());
  },
});

const cancelSupportTicket = async (ticket_id, issue_level_1, cb) => {
  try {
    const res = await cancelTicket({ ticket_id });
    // // toast
    analytics.trackEvent(SUPPORT_FLOW.SUPPORT_TICKET_CANCELLED, {
      type: issue_level_1.toString().toLowerCase(),
    });
    store.dispatch(
      snackbarActions.showSnackbar(
        payload("आपकी टिकट सफलतापूर्वक कैंसिल हो गयी है |"),
      ),
    );
    setTimeout(() => {
      store.dispatch(snackbarActions.hideSnackbar());
    }, 3000);
  } catch (err) {
  } finally {
    if (cb && typeof cb === "function") cb();
  }
};

export default cancelSupportTicket;
